import React, { Component } from 'react'
import { connect } from 'react-redux'
import '../../App.css'
import './style.css'
import {
  Grid, TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  List,
  ListItem,
  MenuItem,
  Checkbox,
  DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog, Button
} from '@material-ui/core';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import Link from '@material-ui/core/Link';
import { AddConsultantFunctionForProject, UpdateConsultantForProject, DeleteConsultantForProject } from './ProjectsAction'

class Consultants extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedList: '',
      deleteSelected: '',
      isDeleteConsultant: false,
      propsProjectData: this.props.project_data,
      error: { project_consultants: [] }
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { error_validation } = this.props;
    const { propsProjectData } = this.state

    if (nextProps.project_data !== propsProjectData) {
      this.setState({ propsProjectData: nextProps.project_data })
    }
    if (nextProps.error_validation !== error_validation) {
      this.setState({ error: nextProps.error_validation })
    }
  }
  AddConsultant = (selectedList) => {
    const { project_data, AddConsultantFunctionForProject } = this.props
    if (selectedList !== '') {
      AddConsultantFunctionForProject(project_data, selectedList)
      this.setState({ selectedList: '' })
    }
  }
  UpdateConsultant = () => {
    const { propsProjectData, deleteSelected } = this.state
    if (deleteSelected)
      UpdateConsultantForProject(propsProjectData)
  }

  DeleteConsultant = (deleteSelected) => {
    const { DeleteConsultantForProject } = this.props
    const { propsProjectData } = this.state
    if (deleteSelected !== '') {
      DeleteConsultantForProject(deleteSelected, propsProjectData)
      this.setState({ deleteSelected: '', isDeleteConsultant: false })
    }
  }

  render() {
    const { selectedList, propsProjectData, deleteSelected, isDeleteConsultant } = this.state
    const { available_consultant, consultant_list, UpdateConsultantForProject, forOther, forOwn, isInactive } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))

    return (
      <div className={
        isInactive ||
        ((Number(access_rights.projects_consultants_for_other) !== 2 && forOther) || (Number(access_rights.projects_consultants_for_own) !== 2 && forOwn)) ?
        "disableALlFields" : ""
      }
      >
        <Grid container spacing={0} className="y-center">
          <Grid item xs={4}>
            <div className="c-title">verfügbare Berater / Funktion</div>
            <div className="c-card">
              <List dense className="c-card-list">
                {available_consultant &&
                  available_consultant.map((consultant, index) => (
                    <ListItem
                      className={selectedList === consultant ? 'active' : ''} key={index} onClick={() => this.setState({ selectedList: consultant })}>
                      {`${consultant.full_name} | ${consultant.category_name === null ? "" : consultant.category_name}`}
                    </ListItem>
                  ))
                }
              </List>
            </div>
          </Grid>
          <Grid item xs={1}>
            <div className="verticalcenterarrow">
              <Link to="">
                <DoubleArrowIcon onClick={() => this.AddConsultant(selectedList)}></DoubleArrowIcon>
              </Link>
              <Link to="">
                <DoubleArrowIcon onClick={() => {
                  if (deleteSelected.has_data)
                    this.setState({ isDeleteConsultant: true })
                  else
                    this.DeleteConsultant(deleteSelected)
                }}></DoubleArrowIcon>
              </Link>
            </div>
          </Grid>
          <Grid item xs={7}>
            <div className="c-title">zugeordnete Berater</div>
            <div className="projectTable zeromargin">
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell width="45%">Berater</TableCell>
                      <TableCell align="left">Funktion</TableCell>
                      <TableCell align="center">Geheim</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className='c-card-list'>
                    {propsProjectData &&
                      propsProjectData.project_consultants.map((element, index) => (
                        <TableRow className={deleteSelected === element ? 'active' : ''} onClick={() => this.setState({ deleteSelected: element })} key={index}>
                          <TableCell align="left">{element.user}</TableCell>
                          <TableCell align="left">
                            <TextField
                              value={element.consultant_function_id}
                              select
                              variant="outlined"
                              className="select-box"
                              size="small"
                              fullWidth
                              onChange={(e) => {
                                element.consultant_function_id = e.target.value
                                this.setState({ propsProjectData }, UpdateConsultantForProject(propsProjectData))
                              }}
                            >
                              {consultant_list &&
                                consultant_list.map(list =>
                                  <MenuItem key={list.id} value={list.id}>{list.name}</MenuItem>
                                )}
                            </TextField>
                          </TableCell>
                          <TableCell align="center">
                            {propsProjectData.secret !== 0 &&
                              <Checkbox
                                checked={element.secret}
                                color="primary"
                                onChange={() => {
                                  element.secret = !element.secret
                                  this.setState({ propsProjectData }, UpdateConsultantForProject(propsProjectData))
                                }}
                              />
                            }
                          </TableCell>
                        </TableRow>
                      ))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <Dialog
              open={isDeleteConsultant}
            >
              <DialogTitle>Berater vom Projekt entfernen</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Für diesen Berater wurden bereits Zeiten erfasst oder Planungen durchgeführt. Möchten Sie den Berater wirklich von diesem Projekt entfernen?
              </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.DeleteConsultant(deleteSelected)} size="small" variant="outlined" color="primary" autoFocus>
                  Bestätigen
              </Button>
                <Button onClick={() => this.setState({ isDeleteConsultant: false })} size="small" variant="outlined" color="secondary">
                  Abbrechen
              </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = ({ projectsData, consultant }) => {
  return {
    available_consultant: projectsData.available_consultant,
    consultant_list: consultant.consultant_list,

  }
};

const mapDispatchToProps = dispatch => {
  return {
    AddConsultantFunctionForProject: (data, stateData) => dispatch(AddConsultantFunctionForProject(data, stateData)),
    UpdateConsultantForProject: (stateData) => dispatch(UpdateConsultantForProject(stateData)),
    DeleteConsultantForProject: (propsProjectData, stateData) => dispatch(DeleteConsultantForProject(propsProjectData, stateData))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Consultants)